// removed by extract-text-webpack-plugin
module.exports = {"bannerWrap":"qempo_BannerStrip_bannerWrap-2CTBWQJ","bannerContent":"qempo_BannerStrip_bannerContent-1OZTsSJ","textWrap":"qempo_BannerStrip_textWrap-1v331ub","white":"qempo_BannerStrip_white-1se8cqm","moreInfo":"qempo_BannerStrip_moreInfo-1j25YP5"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/components/BannerStrip/BannerStrip.scss
// module id = 1682
// module chunks = 0